export class GetAllAppTypesResponse {
  Eligible: boolean;
  CurrentApplicantType: number;
  NextApplicantType: number;
  CurrentPhaseEventID: string;
  NextPhaseEventID: string;
}
